//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  props: {
    value: { type: Boolean, default: false },
    data: { type: Object, default: () => ({}) },
    isCreating: { type: Boolean, default: false },
  },

  data() {
    return {
      model: {
        baseCurrencyId: 0,
        derivedCurrencyId: 0,
        id: 0,
        isInUse: false,
        orderAmountLimit: false,
        maxOrderAmount: undefined,
        maxOrderPrice: undefined,
        minOrderAmount: undefined,
        minOrderPrice: undefined,
        name: '',
        sortId: '',
      },
      errors: {
        minOrderPrice: '',
      },
      minOrderPriceToValidate: '',
    };
  },

  computed: {
    ...mapState('currencies', { currencies: 'inUseCurrencies' }),
    ...mapGetters('currencies', ['getCurrencyById']),

    showModal: {
      get() {
        const { value } = this;
        return value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    cumulativeCurrencyTitle() {
      const { cumulativeCurrencyId } = this.model;
      const currency = this.getCurrencyById(cumulativeCurrencyId);

      if (!currency) return '';
      return currency.title;
    },

    baseTitle() {
      const { baseCurrencyId } = this.model;
      const currency = this.getCurrencyById(baseCurrencyId);

      if (!currency) return '';
      return currency.title;
    },

    derivedTitle() {
      const { derivedCurrencyId } = this.model;
      const currency = this.getCurrencyById(derivedCurrencyId);

      if (!currency) return '';
      return currency.title;
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        const { data } = this;
        this.model = data;
      }
    },
  },

  methods: {
    ...mapActions('common', ['confirmAction']),

    decimalsLimit(value) {
      if (value < this.minOrderPriceToValidate) {
        this.errors.minOrderPrice = this.$t('The minimum order price cannot be less than decimals.');
      } else {
        this.errors.minOrderPrice = '';
      }
    },

    create() {
      this.confirmAction({
        text: 'Are you sure you want to create new market?',
        callback: () => {
          const {
            baseCurrencyId,
            derivedCurrencyId,
            isInUse,
            orderAmountLimit,
            maxOrderAmount,
            maxOrderPrice,
            minOrderAmount,
            minOrderPrice,
            sortId,
          } = this.model;
          const payload = {
            baseCurrencyId,
            derivedCurrencyId,
            isInUse,
            orderAmountLimit,
            maxOrderPrice,
            minOrderPrice,
            sortId,
          };
          if (orderAmountLimit) {
            payload.maxOrderAmount = maxOrderAmount;
            payload.minOrderAmount = minOrderAmount;
          }
          this.$emit('create', payload);
        },
      });
    },

    getMinimum(value) {
      this.model.minOrderPrice = `0.${'0'.repeat(this.getCurrencyById(value).decimals - 1)}1`;
      this.minOrderPriceToValidate = `0.${'0'.repeat(this.getCurrencyById(value).decimals - 1)}1`;
    },

    edit() {
      this.confirmAction({
        text: 'Are you sure you want to edit market?',
        callback: () => {
          const {
            id,
            isInUse,
            orderAmountLimit,
            maxOrderAmount,
            maxOrderPrice,
            minOrderAmount,
            minOrderPrice,
            sortId,
          } = this.model;
          this.$emit('edit', {
            marketId: id,
            isInUse,
            orderAmountLimit,
            maxOrderAmount: orderAmountLimit ? maxOrderAmount : null,
            maxOrderPrice,
            minOrderAmount: orderAmountLimit ? minOrderAmount : null,
            minOrderPrice,
            sortId,
          });
        },
      });
    },
  },
};
